// @ts-nocheck
import * as Types from '../../@types/apiql.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TUpdateProfileMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
  name?: Types.InputMaybe<Types.Scalars['String']>;
  imageUrl?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type TUpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'UpdateProfilePayload', id: string, name?: string | null, imageUrl?: string | null, createdAt: any, lastUpdatedAt: any, clientMutationId?: string | null } | null };


export const UpdateProfileDocument = gql`
    mutation UpdateProfile($id: String!, $name: String, $imageUrl: String) {
  updateProfile(input: {id: $id, name: $name, imageUrl: $imageUrl, clientMutationId: ""}) {
    id
    name
    imageUrl
    createdAt
    lastUpdatedAt
    clientMutationId
  }
}
    `;
export type TUpdateProfileMutationFn = Apollo.MutationFunction<TUpdateProfileMutation, TUpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      imageUrl: // value for 'imageUrl'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<TUpdateProfileMutation, TUpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TUpdateProfileMutation, TUpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<TUpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<TUpdateProfileMutation, TUpdateProfileMutationVariables>;